import React from "react";

import Area from "../../components/Area";
import Category from "../../components/Category";

import styles from "./style.module.scss";

const Tech = () => {
  return (
    <Area title="마이리얼트립 Copy">
      <div className={styles.myRealTripImageWrapper}>
        <img
          className={styles.myRealTripImage}
          src="https://img1.daumcdn.net/thumb/R1280x0/?scode=mtistory2&fname=https%3A%2F%2Fk.kakaocdn.net%2Fdn%2F4rmBC%2FbtqCjeVSjso%2FC5di5jhCp5DCkfoQXAvubk%2Fimg.png"
        />
        <img
          className={styles.myRealTripImage}
          src="https://img1.daumcdn.net/thumb/R1280x0/?scode=mtistory2&fname=https%3A%2F%2Fk.kakaocdn.net%2Fdn%2Fb0n99a%2FbtqCgokWFEc%2FBkow6OiQ2R4DpyaeZrhSW0%2Fimg.png"
        />
        <img
          className={styles.myRealTripImage}
          src="https://img1.daumcdn.net/thumb/R1280x0/?scode=mtistory2&fname=https%3A%2F%2Fk.kakaocdn.net%2Fdn%2FlVtnC%2FbtqCinyINUU%2FzkWKuKx8mnqkh7haRtKaWK%2Fimg.png"
        />
        <img
          className={styles.myRealTripImage}
          src="https://img1.daumcdn.net/thumb/R1280x0/?scode=mtistory2&fname=https%3A%2F%2Fk.kakaocdn.net%2Fdn%2FuA5di%2FbtqCl88dASC%2FJbKQjPxR0kZkipkfMmljl1%2Fimg.png"
        />
        <img
          className={styles.myRealTripImage}
          src="https://img1.daumcdn.net/thumb/R1280x0/?scode=mtistory2&fname=https%3A%2F%2Fk.kakaocdn.net%2Fdn%2FdkkSKJ%2FbtqCgmAD4Su%2FtVtKumkMjD09jKBKMrPwvK%2Fimg.png"
        />
      </div>
      <div className={styles.introWrapper}>
        <span className={styles.intro}>> React.js</span>
        <span className={styles.intro}>> React hooks</span>
        <span className={styles.intro}>> HTML5 / CSS3</span>
        <span className={styles.intro}>> Javascript ES6</span>
        <span className={styles.intro}>> Axios를 이용한 비동기처리</span>
        <span className={styles.intro}>
          > express.js를 이용한 서버사이드 코드 작성
        </span>
        <span className={styles.intro}>
          > React Router Dom을 사용한 SPA 앱 개발
        </span>

        <div className={styles.introWrapper2}>
          <span className={styles.intro}>
            History Routing과 Hash Routing의 차이를 공부했습니다.
          </span>
          <span className={styles.intro}>
            npm의 여러 모듈을 활용하여 오픈소스를 적극적으로 활용했습니다.
          </span>
        </div>
        <a
          className={styles.a}
          href="https://github.com/junbucks7/my-real-trip.git"
        >
          깃헙 주소
        </a>
      </div>
      <div>
        <div>
          <p className={styles.name}>Instagram</p>
        </div>
        <div className={styles.instaWrapper}>
          <img
            className={styles.insta}
            src="https://img1.daumcdn.net/thumb/R1280x0/?scode=mtistory2&fname=https%3A%2F%2Fk.kakaocdn.net%2Fdn%2Fbh6TXo%2FbtqCineuwXA%2FUGVk34DqH554LwzB50EDAK%2Fimg.png"
          />
          <img
            className={styles.insta}
            src="https://img1.daumcdn.net/thumb/R1280x0/?scode=mtistory2&fname=https%3A%2F%2Fk.kakaocdn.net%2Fdn%2FkJ3dJ%2FbtqCgmtNA8b%2FKd7keHakfur9bhZMolZzb0%2Fimg.png"
          />
        </div>
      </div>
      <div className={styles.introWrapper}>
        <span className={styles.intro}>> React.js</span>
        <span className={styles.intro}>> HTML5 / CSS3</span>
        <span className={styles.intro}>> Javascript ES6</span>

        <div className={styles.introWrapper2}>
          <span className={styles.intro}>
            입력한 값을 Instagram Feed로 추가되게하는 프로젝트입니다.
          </span>
          <span className={styles.intro}>
            Javascript ES6 map 문법을 적극적으로 사용하여 React에서 Element를
            출력하는데 익숙해진 프로젝트입니다.
          </span>
        </div>
        <a className={styles.a} href="https://github.com/junbucks7/Insta.git">
          깃헙 주소
        </a>
      </div>
      <div>
        <div>
          <p className={styles.name}>날씨 API</p>
        </div>
        <div>
          <img
            className={styles.api}
            src="https://img1.daumcdn.net/thumb/R1280x0/?scode=mtistory2&fname=https%3A%2F%2Fk.kakaocdn.net%2Fdn%2FG0ZZE%2FbtqCjeVTb1O%2FnUKVieKaeVm7nKz6neWBok%2Fimg.png"
          />
          <img
            className={styles.api}
            src="https://img1.daumcdn.net/thumb/R1280x0/?scode=mtistory2&fname=https%3A%2F%2Fk.kakaocdn.net%2Fdn%2Ft0Xn9%2FbtqCjR0uo87%2FFSFfsQt0KJ3wB6usxZbP6k%2Fimg.png"
          />
        </div>
      </div>
      <div className={styles.introWrapper}>
        <span className={styles.intro}>> React.js</span>
        <span className={styles.intro}>> HTML5 / CSS3</span>
        <span className={styles.intro}>> Javascript ES6</span>
        <span className={styles.intro}>> Axios를 이용한 비동기처리</span>
        <span className={styles.intro}>> 날씨 정보 API 호출</span>
        <div className={styles.introWrapper2}>
          <span className={styles.intro}>
            날씨 API 정보를 페이지 로드시마다 새로운 데이터를 받아서 레이아웃을
            갱신해주었습니다.
          </span>
          <span className={styles.intro}>
            오픈 API를 사용하여 오픈 API의 Document 문서를 읽고 사용하는 방법을
            공부했습니다.
          </span>
        </div>
        <a
          className={styles.a}
          href="https://github.com/junbucks7/WeatherApi.git"
        >
          깃헙 주소
        </a>
      </div>
      <div>
        <p className={styles.name}>블로그 활동</p>
      </div>
      <div>
        <img
          className={styles.api2}
          src="https://img1.daumcdn.net/thumb/R1280x0/?scode=mtistory2&fname=https%3A%2F%2Fk.kakaocdn.net%2Fdn%2FcibVdt%2FbtqClyNsjIs%2FyPEZNqKVY7ezzNYWPWc2D1%2Fimg.png"
        />
        <img
          className={styles.api2}
          src="https://img1.daumcdn.net/thumb/R1280x0/?scode=mtistory2&fname=https%3A%2F%2Fk.kakaocdn.net%2Fdn%2FbmeKnZ%2FbtqCjRz06o3%2FG4Zn9JDWxy5kJjJZ8LNAA0%2Fimg.png"
        />
      </div>
      <div className={styles.introWrapper2}>
        <span className={styles.intro}>
          - 글 작성을 위해 많은 데이터를 취합하고 공부하여 게시글로
          발행하였습니다.
        </span>
        <span className={styles.intro}>
          - 활용법을 잊거나 과거 자신의 히스토리를 참고해야 할때 도움이
          되었습니다.
        </span>
        <span className={styles.intro}>
          - 많은 사람들에게 공개적으로 정보를 공유할 수 있고 피드백을 받을 수
          있어 개발 공부하는데 있어 큰 도움이 되었습니다.
        </span>
        <a className={styles.a} href="https://junbucks7.tistory.com">
          블로그 주소
        </a>
      </div>
    </Area>
  );
};

export default Tech;
